<template>
    <v-main>
        <div class="text-center"> 
        <h1>
            <p>Fichas para Reflexão</p>
        </h1>            
        <p>
            Bem vindo ao aplicativo fichas para reflexão. Pagina inicial com informações relevantes
        </p>
        <p>
            <v-btn dark :to="'/Cards'">Acessar fichas</v-btn>
        </p>
        </div>
    </v-main>
</template>

<script>
export default {	
    name: "Home"
};
</script>
